const isScreenMobile = () => window.matchMedia('(max-width: 768px)').matches;

export default isScreenMobile;
